import { ReactNode } from 'react';
import { noop } from 'lodash';
import { confirmAlert } from 'react-confirm-alert';
import classNames from 'classnames';
import styles from './index.module.scss';
import { isArray } from 'lodash';

export interface ReactConfirmAlertProps {
  title?: string;
  body?: string | ReactNode;
  label?: string;
  onClick?: () => void;
  onCancelClick?: () => void;
  onClickOutside?: () => void;
  subText?: string | string[];
  cancelText?: string;
  classes?: {
    overlay?: string;
    primary?: string;
    secondary?: string;
    body?: string;
    closeBtn?: string;
    subText?: string;
  };
  hideCancel?: boolean;
}
function customConfirmAlert({
  title,
  body,
  onClick,
  label,
  onCancelClick,
  subText,
  classes,
  onClickOutside,
  cancelText,
  hideCancel,
}: ReactConfirmAlertProps) {
  confirmAlert({
    title,
    childrenElement: () => (
      <div className={classNames(styles.bodyText, classes?.body)}>
        <div className={subText && !isArray(subText) ? 'w-4/5' : 'w-full'}>{body}</div>
        {isArray(subText) ? (
          subText?.map((text, index) => (
            <div className={classNames('pt-4', classes?.subText)} key={index}>
              {text ?? ''}
            </div>
          ))
        ) : subText ? (
          <div className={classNames('pt-4', classes?.subText)}>{subText}</div>
        ) : null}
      </div>
    ),
    buttons: [
      ...(hideCancel
        ? []
        : [
            {
              label: cancelText ?? 'Cancel',
              className: classNames(styles.confirmbutton, classes?.secondary, styles.cancelButton),
              onClick: () => (onCancelClick ? onCancelClick() : noop),
            },
          ]),
      {
        label: '',
        className: classNames(styles.closeBtn, classes?.closeBtn, 'closeBtn'),
        onClick: () => (onCancelClick ? onCancelClick() : noop),
      },
      {
        label: label ?? '',
        className: classNames(styles.confirmbutton, styles.confirmPrimary, classes?.primary),
        onClick: () => (onClick ? onClick() : noop),
      },
    ],
    overlayClassName: classNames(classes?.overlay, styles.overlayClass),
    onClickOutside: () => onClickOutside?.(),
  });
}

export default customConfirmAlert;
